import React, { useContext } from 'react';
import { View } from 'react-native';

import ClientContext from 'app/src/contexts/ClientContext';
import ExternalLink from 'app/src/elements/ExternalLink';
import { Text } from 'app/src/styles';

const Video = ({ url, title }) => {
  const { isMobile } = useContext(ClientContext);

  const dimensions = isMobile ?
    { width: '372', height: '208' } :
    { width: '560', height: '312' };

  return (
    <iframe
      {...dimensions}
      src={url}
      title={title}
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    ></iframe>
  );
};

export default Video;
